import { useGastosMensuales } from '@/hooks/useGastos'
import { calcularVariacionFlujo, periodoEnCurso, type PeriodoComparado } from '@/lib/periodo-reporte'
import { formatCurrency } from '@/lib/utils'
import { KpiCard } from './KpiCard'
import { inicioEgresos, sumarEgresos } from './egresos'

interface KpiEgresosProps {
  periodo: PeriodoComparado
  /** Cobrado del período, para calcular lo que queda. undefined mientras carga. */
  ingresos: number | undefined
}

/** KPI de egresos del período. Se monta solo con verCuentas, porque montarlo dispara la consulta de gastos. */
export function KpiEgresos({ periodo, ingresos }: KpiEgresosProps) {
  const { data: rows, isLoading, isError } = useGastosMensuales(periodo.anterior.desde.slice(0, 7))

  const egresos = rows ? sumarEgresos(rows, periodo.actual) : undefined
  const egresosAnt = rows ? sumarEgresos(rows, periodo.anterior) : 0
  const quedan = ingresos !== undefined && egresos !== undefined ? ingresos - egresos : undefined
  // Cada mes entra completo, así que un período que incluye hoy compara un mes parcial con uno cerrado.
  const enCurso = periodoEnCurso(periodo.actual, new Date())
  const variacion =
    egresos === undefined || enCurso
      ? null
      : calcularVariacionFlujo(egresos, egresosAnt, inicioEgresos(rows ?? []), periodo.anterior)

  return (
    <KpiCard
      titulo="Egresos"
      ayuda="Gastos del estudio en pesos, sin retiros de socios. Suma completos los meses que toca el período, así que la variación solo se muestra con un período cerrado. «Te quedan» es lo cobrado menos los egresos."
      valor={egresos}
      variacion={variacion}
      sinVariacion={enCurso ? 'Incluye el mes en curso' : undefined}
      mejorSiSube={false}
      isLoading={isLoading}
      isError={isError}
      detalle={
        quedan !== undefined && (
          <p>
            Te quedan {formatCurrency(quedan)}
            {ingresos ? ` (${Math.round((quedan / ingresos) * 100)}%)` : ''}
          </p>
        )
      }
    />
  )
}
